import isEqual from 'lodash/isEqual';
import React, { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMount, useUnmount } from 'react-use';
import {
  getQuery,
  getQueryClassicRewards,
  getQueryDepositPay,
  getQueryFreeCancellation,
} from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { fetchPropertyAvailability, clearResults, setFilters } from 'store/propertyAvailability/propertyAvailabilityActions';
import { getTreatments } from 'store/split/splitSelectors';
import RoomTypes from './RoomTypes';

// drop this down as a sub component so that changes to the query doesn't cause the RoomTypes to re-render unnecessarily
const ResultsFetcher = () => {
  const dispatch = useDispatch();
  const query = useSelector(getQuery, isEqual);
  const classicRewards = useSelector(getQueryClassicRewards);
  const depositPay = useSelector(getQueryDepositPay);
  const freeCancellation = useSelector(getQueryFreeCancellation);
  const splitTreatments = useSelector(getTreatments);

  useMount(() => {
    if (splitTreatments?.property_page_filters?.treatment === 'on') {
      const filters = {
        classicRewards: !!classicRewards,
        depositPay: !!depositPay,
        freeCancellation: !!freeCancellation,
      };

      dispatch(setFilters(filters));
    }
  });

  useEffect(() => {
    dispatch(fetchPropertyAvailability());
  }, [dispatch, query]);

  //clear results when we leave the page
  useUnmount(() => {
    dispatch(clearResults());
  });

  return null;
};

const PropertyAvailability = () => (
  <Fragment>
    <ResultsFetcher />
    <RoomTypes />
  </Fragment>
);

export default PropertyAvailability;
